import React from 'react'
import { EffectCoverflow, Navigation, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

function InSectionThree({ itemData }) {
   return (
      <>
         <div className="model_train_slider industries-003-slider container position-relative">
            <Swiper
               modules={[Navigation, Pagination, EffectCoverflow]}
               slidesPerView={2}
               spaceBetween={30}
               loop={true}
               navigation={{
                  nextEl: '.model_train_slider_custom_next_btn3',
                  prevEl: '.model_train_slider_custom_prev_btn3',
               }}
               centeredSlides={false}
               pagination={{
                  el: '.fintach-pagination',
                  dynamicBullets: false,
                  clickable: true,
                  renderBullet: function (index, className) {
                     return `<span class="${className} custom-dark-bullet"></span>`
                  },
               }}
               effect="coverflow"
               breakpoints={{
                  320: {
                     slidesPerView: 1,
                     spaceBetween: 80,
                  },
                  769: {
                     slidesPerView: 1,
                     spaceBetween: 50,
                  },
                  1025: {
                     slidesPerView: 2,
                     spaceBetween: 12,
                     coverflowEffect: {
                        rotate: 0,
                        stretch: -10,
                        depth: 1,
                        modifier: 1,
                        slideShadows: false,
                     },
                  },
               }}
               className="model_train_slider container-fluid position-relative custom-slider-3"
            >
               {itemData.map((service, index) => (
                  <SwiperSlide key={index}>
                     <div className="model-train-card">
                        <div className="text-center in-model-card">
                           <div className="d-flex text-start multi-platform-title">
                              <div className="multi-platform-card_img">
                                 <img src={service.image} />
                              </div>
                              <div className="multi-platform-cards_title align-content-center">
                                 <h3>{service.title}</h3>
                              </div>
                           </div>
                        </div>
                        <div className="multi_platform_border"></div>
                        <div className="in-silder-desc">
                           <p className="text-start">{service.description}</p>
                        </div>
                     </div>
                  </SwiperSlide>
               ))}
            </Swiper>
         </div>
         <div className="d-flex justify-content-center slider-1-navigation-parent fintach_pagination_new_slider mt-2">
            <div className="model_train_slider_custom_prev_btn3 fintach_btn_new"></div>
            <div className="d-flex align-items-center justify-content-center">
               <span className="d-flex align-items-center justify-content-center fintach-pagination"></span>
            </div>
            <div className="model_train_slider_custom_next_btn3 fintach_btn_new"></div>
         </div>
      </>
   )
}

export default InSectionThree
